/**
 * ornaments.tsx — primitivas decorativas compartidas del Home.
 *
 * Extraídas de `pages/Home.tsx` (2026-09-22): `StarDot` se usa 17 veces a lo
 * largo de la página y `MoonCrescent` en el bloque de terapias, así que viven
 * en su propio módulo en vez de inflar la page. Ninguna lleva color quemado:
 * heredan `currentColor` y el tamaño por prop (ADR-006).
 */
import { cn } from '../../lib/cn';

/** Estrella decorativa pequeña (✦) dorada. */
export function StarDot({ className }: { className?: string }) {
  return (
    <span aria-hidden="true" className={cn('select-none text-gold-500', className)}>
      ✦
    </span>
  );
}

/** SVG luna creciente — inline, sin hex (currentColor). */
export function MoonCrescent({ className, size = 64 }: { className?: string; size?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable={false}
    >
      <path d="M44 12 a22 22 0 1 0 8 28 18 18 0 0 1 -8 -28 z" />
    </svg>
  );
}
